import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["categoryList", "categoryWidth"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useRef, useEffect, useState } from 'react';
import { Text, View, Pressable, ScrollView, Animated, Easing } from 'react-native';
import LinearGradient from 'react-native-linear-gradient'; // import { LinearGradient } from 'expo-linear-gradient'; // expo 报错使用这个

import { compatibleWebSvg } from '.';
import { Image } from '../../Image/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import CategoryIcon from './icon';
import { FONT_WEIGHT_REGULAR, FONT_WEIGHT_MEDIUM } from '../../../styles/rn';
import { replaceSpaceWithNewline } from './tools';
import Group2AdhocArrow from './icon/Group2AdhocArrow';
import AnimationArrow from './icon/AnimationArrow';
import { emitTrackingEvent, useComponentTracking, useTracking } from '../../../hooks/rn/useTracking';
import { debounce } from '../../../utils/lodashReplacement';
import { useLocale } from '../../LocaleProvider/rn';
var iconWidth = 24;
var iconHeight = 24;
var animationArrowStart = 4;
var animationArrowEnd = 0;
var HotQuestionCategoryGroup2ItemContainerMarginRight = 4;
var iconColor = '#EE4D2D';
var adhocLabelOverflowTop = 5;
export var SMALLER_CATEGORY_TAB_TRACKER_SCOPE = 'SMALLER_CATEGORY_TAB_TRACKER_SCOPE';
export var HotQuestionCategoryGroup2Item = function HotQuestionCategoryGroup2Item(props) {
  var isAdHoc = props.isAdHoc,
    icon = props.icon,
    isLastItem = props.isLastItem,
    _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    _props$adhocLabel = props.adhocLabel,
    adhocLabel = _props$adhocLabel === void 0 ? '' : _props$adhocLabel,
    index = props.index,
    HandleSetAllCategoryWidthList = props.HandleSetAllCategoryWidthList,
    onCategoryClick = props.onCategoryClick;
  var _useTracking = useTracking(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var _useLocale = useLocale(),
    region = _useLocale.region;
  var nameLen = name === null || name === void 0 ? void 0 : name.length;
  var maxCharacterLen = 13;
  var itemName = nameLen > maxCharacterLen ? replaceSpaceWithNewline(name) : name;
  var getAdhocIcon = function getAdhocIcon() {
    if (!isAdHoc || !icon) {
      return null;
    }
    var isSVG = icon.split('.').pop().startsWith('svg'); // 识别资源是否是 svg

    if (isSVG) {
      return compatibleWebSvg({
        width: iconWidth,
        height: iconHeight,
        icon: icon
      });
    } else {
      return /*#__PURE__*/React.createElement(Image, {
        width: iconWidth,
        height: iconHeight,
        src: icon
      });
    }
  };
  var onLayout = function onLayout(event) {
    var width = event.nativeEvent.layout.width;
    HandleSetAllCategoryWidthList(index, width);
  };
  return /*#__PURE__*/React.createElement(Pressable, _extends({
    style: [Styles['item-container'], {
      marginRight: isLastItem ? 0 : HotQuestionCategoryGroup2ItemContainerMarginRight
    }],
    onLayout: onLayout,
    onPress: function onPress() {
      trackingClick && tracker.click(trackingClick);
      onCategoryClick === null || onCategoryClick === void 0 ? void 0 : onCategoryClick(props);
    }
  }, trackingImpressionProps), /*#__PURE__*/React.createElement(View, {
    style: [Styles['item-icon']]
  }, isAdHoc ? getAdhocIcon() : /*#__PURE__*/React.createElement(CategoryIcon, {
    icon: icon,
    width: iconWidth,
    height: iconHeight,
    color: iconColor
  })), /*#__PURE__*/React.createElement(Text, {
    style: [Styles['item-name'], region === 'th' && {
      lineHeight: 16
    }],
    numberOfLines: 2
  }, itemName), isAdHoc ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinearGradient, {
    colors: ['#EE4D2D', '#F37D65'] // 渐变颜色数组
    ,

    start: {
      x: 0,
      y: 0
    } // 渐变开始点 (x,y)
    ,

    end: {
      x: 1,
      y: 0
    } // 渐变结束点 (x,y)
    ,

    style: [Styles['item-label-container']]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [Styles['item-label']]
  }, adhocLabel || 'Hot')), /*#__PURE__*/React.createElement(Group2AdhocArrow, {
    style: Styles['item-label-adhoc-arrow']
  })) : null);
};
export var HotQuestionCategoryGroup2 = function HotQuestionCategoryGroup2(props) {
  var _props$categoryList = props.categoryList,
    categoryList = _props$categoryList === void 0 ? [] : _props$categoryList,
    categoryWidth = props.categoryWidth,
    otherProps = _objectWithoutProperties(props, _excluded);
  var animatedValue = useRef(new Animated.Value(animationArrowStart)).current;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    animationArrowDisplay = _useState2[0],
    setAnimationArrowDisplay = _useState2[1];
  var categoryListLen = categoryList === null || categoryList === void 0 ? void 0 : categoryList.length;
  var animationArrowFirst = useRef(true); // const [allCategoryWidthList, setAllCategoryWidthList] = useState<number[]>(
  //   categoryListLen ? new Array(categoryListLen).fill(undefined) : []
  // );

  var allCategoryWidthList = useRef(categoryListLen ? new Array(categoryListLen).fill(0) : []);
  var _useComponentTracking = useComponentTracking(props),
    tracker = _useComponentTracking.tracker,
    result = _useComponentTracking.result;
  var _ref = result || {},
    smallerTab = _ref.smallerTab;
  var animateArrow = function animateArrow() {
    Animated.sequence([Animated.delay(500), Animated.timing(animatedValue, {
      toValue: animationArrowEnd,
      duration: 300,
      easing: Easing.in(Easing.ease),
      useNativeDriver: false
    }), Animated.timing(animatedValue, {
      toValue: animationArrowStart,
      duration: 300,
      easing: Easing.out(Easing.ease),
      useNativeDriver: false
    })]).start(function () {
      return animateArrow();
    });
  };
  var debounceTrackScroll = debounce(function () {
    if (smallerTab !== null && smallerTab !== void 0 && smallerTab.trackingScroll) {
      tracker.scroll(smallerTab.trackingScroll);
    }
  }, 1000, undefined);
  var onScroll = function onScroll() {
    emitTrackingEvent(SMALLER_CATEGORY_TAB_TRACKER_SCOPE);
    setAnimationArrowDisplay(false);
    debounceTrackScroll();
  };
  var HandleSetAllCategoryWidthList = function HandleSetAllCategoryWidthList(index, value) {
    if (animationArrowFirst.current) {
      allCategoryWidthList.current[index] = value;
      if (~allCategoryWidthList.current.indexOf(0)) {
        return;
      }
      var allCategoryWidthListLen = allCategoryWidthList.current.length;
      var totalWidth = 0;
      for (var i = 0; i < allCategoryWidthListLen; i++) {
        var width = allCategoryWidthList.current[i];
        totalWidth = width + (i === 0 ? 0 : HotQuestionCategoryGroup2ItemContainerMarginRight) + totalWidth;
        if (typeof categoryWidth === 'number') {
          var diff = categoryWidth - totalWidth;
          if (diff >= 15 && diff <= 23) {
            setAnimationArrowDisplay(true);
            animationArrowFirst.current = false;
            break;
          }
        }
      }
    }
  };
  useEffect(function () {
    animateArrow();
  }, []);
  return /*#__PURE__*/React.createElement(View, {
    style: [Styles.container]
  }, /*#__PURE__*/React.createElement(ScrollView, {
    contentContainerStyle: [Styles['scroll-view-container']],
    horizontal: true,
    scrollEventThrottle: 16,
    onScroll: onScroll,
    onLayout: function onLayout() {
      emitTrackingEvent(SMALLER_CATEGORY_TAB_TRACKER_SCOPE);
    },
    showsHorizontalScrollIndicator: false
  }, categoryList.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(HotQuestionCategoryGroup2Item, _extends({}, item, {
      key: idx
    }, otherProps, {
      isLastItem: idx === categoryList.length - 1,
      index: idx,
      HandleSetAllCategoryWidthList: HandleSetAllCategoryWidthList
    }));
  })), animationArrowDisplay ? /*#__PURE__*/React.createElement(Animated.View, {
    style: [Styles['animation-arrow-container'], {
      right: animatedValue
    }]
  }, /*#__PURE__*/React.createElement(AnimationArrow, null)) : null);
};
var Styles = CustomStyleSheet({
  container: {
    position: 'relative',
    width: '100%'
  },
  'scroll-view-container': {
    height: 45.6 + adhocLabelOverflowTop,
    flexDirection: 'row',
    paddingTop: adhocLabelOverflowTop,
    position: 'relative',
    paddingHorizontal: 15
  },
  'item-container': {
    height: 44,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 12,
    backgroundColor: '#FFF',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    elevation: 1,
    shadowColor: 'rgba(0, 0, 0, 0.10)',
    shadowOffset: {
      width: 0,
      height: 1
    },
    shadowOpacity: 1,
    shadowRadius: 1,
    marginBottom: 1.6
  },
  'item-icon': {
    width: iconWidth,
    height: iconHeight,
    marginRight: 6
  },
  'item-name': _objectSpread(_objectSpread({}, FONT_WEIGHT_REGULAR), {}, {
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 89
  }),
  'item-label-container': {
    borderRadius: 8,
    borderBottomRightRadius: 0,
    // backgroundColor: '#EE4D2D',
    height: 14,
    justifyContent: 'center',
    position: 'absolute',
    right: -3,
    top: -adhocLabelOverflowTop,
    paddingHorizontal: 6,
    zIndex: 9999
  },
  'item-label-adhoc-arrow': {
    position: 'absolute',
    right: -3,
    top: 9
  },
  'item-label': _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 9,
    color: '#FFF',
    lineHeight: 14
  }),
  'animation-arrow-container': {
    position: 'absolute',
    bottom: 13.6,
    // shadowColor: 'rgba(0, 0, 0, 0.06)',
    // shadowOffset: {
    //   width: 0,
    //   height: 0,
    // },
    // shadowOpacity: 1,
    // shadowRadius: 6,
    elevation: 1,
    shadowColor: 'rgba(0, 0, 0, 0.12)',
    shadowOffset: {
      width: 0,
      height: 0
    },
    shadowOpacity: 1,
    shadowRadius: 9,
    borderRadius: 100,
    backgroundColor: '#FFF',
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center'
  }
});